import React from 'react'
import { TertiaryButtonDark } from '../../../core/components/unilink/index'
import LoadingSpinner from '../../../core/components/loading-spinner/LoadingSpinner'
import './profileFeed.css'

const ProfileFeed = ({ className, children, showMore, canLoadMore, isFetching }) => {
  return (
    <div className="profile-feed">
      <div className="profile-feed__container gridcontainer">
        <div className="profile-feed__chunks">{children}</div>
        {
          isFetching
            ? <LoadingSpinner />
            : canLoadMore
              ? (
                <TertiaryButtonDark
                  className="profile-feed__show-more"
                  onClick={showMore}
                >
                Show More
                </TertiaryButtonDark>
              )
              : null
        }
      </div>
    </div>
  )
}
export default ProfileFeed



// WEBPACK FOOTER //
// ./src/domains/user/components/ProfileFeed.js